module.exports = __webpack_public_path__ + "static/media/diktat-38.b0f8079f.mp3";